import * as React from 'react';

const VerticalDotsSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd">
            <path
                d="M12 7a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4zm0-7a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2z"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

VerticalDotsSvg.displayName = 'VerticalDotsSvg';
export default VerticalDotsSvg;
